var _mask, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 917,
    height: 149,
    viewBox: "0 0 917 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 74.5C67 113.114 37.6233 144.866 0 148.627V149H842.5H843V148.998C883.915 148.729 917 115.478 917 74.5C917 33.5216 883.915 0.270557 843 0.0016427V0H842.5H0V0.372827C37.6233 4.13382 67 35.8863 67 74.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 74.5C67 113.114 37.6233 144.866 0 148.627V149H842.5H843V148.998C883.915 148.729 917 115.478 917 74.5C917 33.5216 883.915 0.270557 843 0.0016427V0H842.5H0V0.372827C37.6233 4.13382 67 35.8863 67 74.5Z",
    fill: "currentColor",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 148.627L-2.38725 124.746L-24 126.907V148.627H0ZM0 149H-24V173H0V149ZM843 149V173H867V149H843ZM843 148.998L842.842 124.999L819 125.156V148.998H843ZM843 0.0016427H819V23.8444L842.842 24.0011L843 0.0016427ZM843 0H867V-24H843V0ZM0 0V-24H-24V0H0ZM0 0.372827H-24V22.0933L-2.38725 24.2538L0 0.372827ZM2.38725 172.508C52.1564 167.533 91 125.568 91 74.5H43C43 100.66 23.0901 122.199 -2.38725 124.746L2.38725 172.508ZM24 149V148.627H-24V149H24ZM842.5 125H0V173H842.5V125ZM843 125H842.5V173H843V125ZM819 148.998V149H867V148.998H819ZM893 74.5C893 102.276 870.573 124.817 842.842 124.999L843.158 172.998C897.257 172.642 941 128.68 941 74.5H893ZM842.842 24.0011C870.573 24.1834 893 46.7236 893 74.5H941C941 20.3196 897.257 -23.6423 843.158 -23.9978L842.842 24.0011ZM819 0V0.0016427H867V0H819ZM842.5 24H843V-24H842.5V24ZM0 24H842.5V-24H0V24ZM24 0.372827V0H-24V0.372827H24ZM91 74.5C91 23.4324 52.1564 -18.533 2.38725 -23.5081L-2.38725 24.2538C23.0901 26.8006 43 48.3402 43 74.5H91Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepOutline);
export default __webpack_public_path__ + "static/media/step_outline.224e8ea3.svg";
export { ForwardRef as ReactComponent };